import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerRequirementsDetailsComponent } from './customer-requirements-details.component';

const routes: Routes = [
  { path: '', component: CustomerRequirementsDetailsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerRequirementsDetailsRoutingModule {}
